export const CLIENT_DEFAULT_VALUES = {
  company_id: '',
  country: {
    id: 0,
    name: '',
    code: '',
  },
  client_type: 'zakelijk' as 'particulier' | 'zakelijk',
  name: '',
  code: '',
  email: '',
  street: '',
  house_number: '',
  house_number_addition: '',
  postal_code: '',
  city: '',
  coc: '',
  tax: '',
  hourly_rate: null,
  created_at: null,
  updated_at: null,
  deleted_at: null,
  contacts: [],
}
